import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=bcdd9d68&scoped=true&lang=pug&"
import script from "./Case.vue?vue&type=script&lang=js&"
export * from "./Case.vue?vue&type=script&lang=js&"
import style0 from "./Case.styl?vue&type=style&index=0&id=bcdd9d68&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdd9d68",
  null
  
)

export default component.exports